import RolesApi from "./../api/RolesApi";
import PlantelApi from "./../api/SchoolsApi";
import CatalogosApi from "./../api/CatalogosApi";

import { message } from "antd";


import alerts from "../shared/alerts";

export default {
    getSchools: async () => {
        const response = await PlantelApi.getSchools();
        return response;
    },
    getRoles: async () => {
        const response = await RolesApi.getRoles();
        return response;
    },
    fetchRolesBySystemCode: async (system_code) => {
        if (!system_code) {
            alerts.error("Error al obtener roles autorizados", "ID de sistema no proporcionado");
        }
        const response = await RolesApi.fetchRolesBySystemCode(system_code);
        if (!response.success) {
            message.error(response.message);
            return response.data = [];
        };
        return response;
    }, 
    getEstados: async () => {
        const response = await CatalogosApi.getEstados();
        if (!response.success) {
            alerts.error("Error al obtener estados", response.message);
            response.data = [];
        }
        return response;
    },
    getMunicipios: async () => {
        const response = await CatalogosApi.getMunicipios();
        if (!response.success) {
            alerts.error("Error al obtener municipios", response.message);
            response.data = [];
        }
        return response;
    },
    getMunicipiosByEstado: async (id_estado) => {
        const response = await CatalogosApi.getMunicipiosByEstado(id_estado);
        if (!response.success) {
            alerts.error("Error al obtener municipios", response.message);
            response.data = [];
        }
        return response;
    },
    getLocalidades: async () => {
        const response = await CatalogosApi.getLocalidades();
        if (!response.success) {
            alerts.error("Error al obtener localidades", response.message);
            response.data = [];
        }
        return response;
    },
    getLocalidadesByCP: async (codigo_postal) => {
        const response = await CatalogosApi.getLocalidadesByCP(codigo_postal);
        if (!response.success) {
            alerts.error("Error al obtener localidades", response.message);
            response.data = [];
        }
        return response;
    },
    getCarreras: async () => {
        const response = await CatalogosApi.getCarreras();
        if (!response.success) {
            alerts.error("Error al obtener carreras", response.message);
            response.data = [];
        }
        return response;
    },
    fetchMySchools: async () => {
        const response = await PlantelApi.fetchMySchools();
        if (!response.success) {
            alerts.error("Error al obtener el plantel", response.message);
            response.data = [];
        }
        return response;
    },
};